// removed by extract-text-webpack-plugin
module.exports = {"summaryHrWrap":"qempo_Summary_summaryHrWrap-3ghLqOI","summaryHr":"qempo_Summary_summaryHr-odsh-65","summaryRowWrap":"qempo_Summary_summaryRowWrap-2hf_91c","noTopPadding":"qempo_Summary_noTopPadding-3WNzXRT","green":"qempo_Summary_green-3KJGGPa","spanContent":"qempo_Summary_spanContent-1yzksRZ","lightBlue":"qempo_Summary_lightBlue-lOv21F1","color":"qempo_Summary_color-3MzuDjH","bold":"qempo_Summary_bold-3VpoEwT"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Summary/Summary.scss
// module id = 1355
// module chunks = 0